export enum EventPriceTypeEnum {
    ByEvent,
    BySemester
}